module.exports = __webpack_public_path__ + "images/b9df30d.jpg";